export const SET_CONVERSION_RULES = 'SET_CONVERSION_RULES';
export const SET_PAGINATION = 'SET_PAGINATION';
export const DELETE_CONVERSION_RULES = 'DELETE_CONVERSION_RULES';
export const SET_FILES_CONVERTER = 'SET_FILES_CONVERTER';
export const SET_FILE_FORMATS = 'SET_FILE_FORMATS';
